import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SuccessMessageService {
    private successMessageSubject = new BehaviorSubject<string>("");

    successMessage$ = this.successMessageSubject.asObservable();

    setSuccessMessage(message: string): void {
        this.successMessageSubject.next(message);
    }
}
